<template>
  <div class="block latestPostBlock infoDivMain">
    <v-container>
      <h2 class="text-center infoH">ВСИЧКО ЗА НАС</h2>
      <div data-field="summary-body">
        <div class="infoDiv">
          Къща за гости Никол се намира в град Хисаря, на 50 метра от новата
          колонада и централния площад.
        </div>
        <div style=""><br /></div>
        <div class="infoDiv">
          Къщата разполага с една спалня и една двойна стая със самостоятелни
          санитарни възли. Има тераса и кът за отдих. <br />В стаите има
          безжична интернет връзка и телевизори с кабелна телевизия.
          <br />Предлагаме възможност за паркинг на Вашия автомобил в двора.
          Къщата разполага и с видеонаблюдение.
        </div>
        <div class="infoDiv">
          Мястото е заобиколено от хотели с минерални басейни и спа процедури -
          базата на ВМА /военен санаториум/ и други. Собственикът е пчелар и
          предлага чист пчелен мед.<br />
          <p class="infoP">
            Цената на стая е 30лв. При повече нощувки цената е 25лв.<br />
            Заповядайте!
          </p>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Info",

  data() {
    return {
      items: [],
    };
  },
};
</script>
